<template lang="pug">
  vSelect.entrychannel-select(:value="selectedOption" :options="options" label="name" @input="onInput" :placeholder="loading ? 'Loading...' : placeholder" :disabled="loading === true || disabled === true")
</template>
<script>

import vSelect from 'vue-select'
import Core from '@/service/apis/Core'

export default {
  props: {
    value: {
      type: null
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data: () => ({
    options: [],
    selectedOption: null,
    placeholder: 'Select A Channel',
    loading: false
  }),
  created() {
    this.loading = true
    Core.listEntryChannelsV2({ size: 1000 })
      .then((resp) => {
        this.options = resp.data.content
        this.updateSelectedOption()
      })
      .catch((e) => {
        this.placeholder = e.response.data.message
      })
      .then(() => { this.loading = false })
  },
  methods: {
    updateSelectedOption() {
      if (this.value) {
        this.selectedOption = this.options.find((o) => o.id === this.value)
      } else {
        this.selectedOption = null
      }
    },
    onInput(val) {
      this.$emit('input', val ? val.id : null)
    },
    getSelectedEntrychannel() {
      return this.selectedOption
    },
    setSelectedEntrychannel(entryChannel) {
      const exisiting = this.options.find((o) => o.id === entryChannel.id)
      if (!exisiting) {
        this.options.push(entryChannel)
      }
    }
  },
  watch: {
    value() {
      this.updateSelectedOption()
    }
  },
  components: {
    vSelect
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ssp/EntrychannelSelect.vue